<template>
  <el-input clearable v-bind="{ ...$attrs, ...props.config }" />
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "search-input",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
